import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/不通过.svg'
import _imports_1 from '@/assets/通过.svg'
import _imports_2 from '@/assets/待审核.svg'


const _withScopeId = n => (_pushScopeId("data-v-28b1abd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "itemBox flex between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shurukuang-riqi",
  style: {"font-size":"20px","margin-top":"-9px"}
}, null, -1))
const _hoisted_3 = { class: "itemBox flex between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"10px"} }, null, -1))
const _hoisted_5 = { class: "searchBox" }
const _hoisted_6 = {
  key: 0,
  style: {"padding":"0 0 0 20px","margin-top":"10px","width":"calc(100% + 20px)"}
}
const _hoisted_7 = { style: {"height":"50px","line-height":"50px","font-size":"12px","color":"#000000","font-weight":"600"} }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex between" }
const _hoisted_10 = { style: {
              color: '#008BCF',
              'font-weight': '600',
              'font-size': '16px',
            } }
const _hoisted_11 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_13 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_14 = { class: "stateTips" }
const _hoisted_15 = { class: "serialNumber" }
const _hoisted_16 = { class: "terminalNameContainer" }
const _hoisted_17 = { class: "terminalNameBox longBox" }
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ff4d4f","margin-right":"10px"} }, "*", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未通过原因", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 10px 0 5px"} }, ":", -1))
const _hoisted_24 = { style: {"color":"#ff4d4f"} }
const _hoisted_25 = { style: {"cursor":"pointer","font-size":"14px"} }
const _hoisted_26 = { style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"14px","padding-right":"40px"} }
const _hoisted_27 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "地址", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_30 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "渠道", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_33 = {
  style: {"font-size":"12px","color":"#8c8c8c","margin-bottom":"4px"},
  class: "flex"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "labelBox" }, "坐标", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"5px"} }, ";", -1))
const _hoisted_37 = { class: "positionTips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RangePicker = _resolveComponent("RangePicker")!
  const _component_Form_item = _resolveComponent("Form-item")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_Table = _resolveComponent("Table")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_PositionIcon = _resolveComponent("PositionIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      model: _ctx.formState,
      ref: "formRef",
      class: "Map_auditLog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Form_item, {
            label: "时间区间",
            name: "rangePicker",
            colon: false,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_RangePicker, {
                disabledDate: _ctx.disabledDate,
                value: _ctx.formState.rangePicker,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.rangePicker) = $event)),
                onCalendarChange: _ctx.onCalendarChange,
                onOpenChange: _ctx.onOpenChange,
                style: {"width":"100%"},
                allowClear: ""
              }, {
                suffixIcon: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabledDate", "value", "onCalendarChange", "onOpenChange"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form_item, {
            label: "审核结果",
            name: "auditStatus",
            colon: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                value: _ctx.formState.auditStatus,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.auditStatus) = $event)),
                options: _ctx.auditStatusOptions,
                placeholder: "请选择"
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _hoisted_4,
          _createVNode(_component_Form_item, {
            label: " ",
            colon: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  type: "primary",
                  onClick: _ctx.search,
                  disabled: _ctx.formState.rangePicker.length < 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode(" 搜索 ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  style: {"margin-left":"10px","border-color":"#008bcf","color":"#008bcf"},
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode(" 重置 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    (this.showData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, " 数据查询结果(共" + _toDisplayString(_ctx.total) + "条) ", 1),
          _createElementVNode("div", {
            style: _normalizeStyle({
        height: _ctx.resultHeight,
        'overflow-y': 'auto',
        'padding-right': '20px',
      })
          }, [
            (this.dataList.length === 0)
              ? (_openBlock(), _createBlock(_component_Empty, {
                  key: 0,
                  description: "未找到匹配的数据",
                  style: {"margin-top":"60px"}
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"border":"1px dashed rgba(224, 224, 224, 1)","border-radius":"4px","padding":"22px 0 12px 60px","margin-bottom":"10px","position":"relative"},
                key: item.auditCode,
                onClick: ($event: any) => (_ctx.clickItem(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(item.fmesName) + " ", 1),
                    (item.auditStatus === '不通过')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                      : _createCommentVNode("", true),
                    (item.auditStatus === '通过')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                      : _createCommentVNode("", true),
                    (item.auditStatus === '待审核')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Popover, {
                      placement: "rightTop",
                      class: "masterMap",
                      trigger: "click",
                      onClick: _withModifiers(($event: any) => (_ctx.clickPop(item)), ["stop"])
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_Table, {
                              rowKey: "fmesCode",
                              columns: _ctx.columns,
                              "data-source": _ctx.detailsList,
                              pagination: false
                            }, {
                              serialNumber: _withCtx(({ index }) => [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(index + 1), 1)
                              ]),
                              signType: _withCtx(({ record }) => [
                                _createElementVNode("span", null, _toDisplayString(record.signType === 1 ? "保留" : "重复"), 1)
                              ]),
                              terminalName: _withCtx(({ record }) => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("span", {
                                        href: "javascript:",
                                        class: "terminalName",
                                        title: record.fmesName
                                      }, _toDisplayString(record.fmesName), 9, _hoisted_18)
                                    ]),
                                    _createElementVNode("div", {
                                      class: "terminalNameBox longBox",
                                      style: {"color":"#ccc"},
                                      title: record.storeShortId
                                    }, _toDisplayString(record.storeShortId), 9, _hoisted_19)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["columns", "data-source"]),
                            (item.auditStatus === '不通过')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _hoisted_21,
                                  _hoisted_22,
                                  _hoisted_23,
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.computedReason()), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createTextVNode(" 查看详情 "),
                          _createVNode(_component_RightOutlined, { style: {"position":"relative","top":"1px"} })
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.storeShortId), 1),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _hoisted_29,
                  _createElementVNode("span", null, _toDisplayString(item.address), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _hoisted_32,
                  _createElementVNode("span", null, _toDisplayString(item.kindCategory) + ">" + _toDisplayString(item.kind) + ">" + _toDisplayString(item.channel), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(item.baiduLat) + " ", 1),
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(item.baiduLon), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_PositionIcon, {
                    index: index + 1,
                    bgcolor: "#008BCF"
                  }, null, 8, ["index"])
                ])
              ], 8, _hoisted_8))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}